export default "__VITE_ASSET__058a24c5__"